export const useDebugStore = defineStore('debug', {
  state: () => ({
    ignoreDirectorUpdates: false,
    timelines: [],
  }),
  actions: {
    toggleDirectorUpdates() {
      this.ignoreDirectorUpdates = !this.ignoreDirectorUpdates
    },
    add(name, timeline) {
      const nameWithCurrentTime = `${name} (${new Date().toLocaleTimeString()})`

      this.timelines.push({ name: nameWithCurrentTime, timeline, key: crypto?.randomUUID() || nameWithCurrentTime })

      // Only keep last 5 timelines to prevent memory leaks
      this.timelines = this.timelines.slice(-5)
    },
  },
})
